import { useEffect, useState } from 'react';
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles, onCellClicked } from './Helpers';
import { fileKeyImg, vectorImg, resolveImage } from "../../images/ImageResolver";

function transformData(data){
  const rowKeys = ["statementSection","endpoints"]
  let tData = data.map(row => ({
    name: row.financialConceptDescription+','+row.financialConceptCode+','+row.segmentType+','+row.hierarchy,
    public: "",
    private: row.private,
    advanced: row.advanced,
    professional: row.advanced,
    rowData: rowKeys.map(key => (row[key] ? row[key].replace(/,/g, "") : "")).join(",")
  }))
  return tData
}

function Segments() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.name.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Segments").then((res) => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    if(!wealth){
      grid.addEventListener("click", onCellClicked);
    }
  }, [wealth]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'name', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon },
      { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
      { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon },
      { name: 'dataRow' , field: 'rowData', visible: false}
    ]

    let onRowExpansionBinding = function(e) {
      let rowData = e.originalRowData;
      var data = rowData ? rowData["rowData"].split(',') : [];
      let rowIndex = e["rowIndex"];
      let section = e["section"];
      let cell = section.stretchCell(0, rowIndex, true);

      if (e.rowExpansion && rowData) {
        // render
        cell.setStyle("backgroundColor", "#FFFFFF");
        section.setRowHeight(rowIndex, 250); // Customized height

        let expContent = cell.getContent();
        if (!expContent || !expContent._myExpansion) {
          expContent = document.createElement("div");
          expContent._myExpansion = true;

          let secondLine = expContent._secondLine = document.createElement("ef-layout");
          secondLine.style.display = "flex";
          secondLine.style.paddingBottom = "10px";
          let thridLine = expContent._thirdLine = document.createElement("ef-layout");
          thridLine.style.paddingLeft = "5px";
          thridLine.style.marginTop = "10px";

          let descLayout = document.createElement("ef-layout");
          descLayout.style.width = "60%";
          descLayout.style.fontWeight = "400";
          descLayout.style.backgroundColor = "transparent";
          descLayout.style.color = "#666666";
          descLayout.style.border = "none";
          descLayout.style.padding = "10px 30px 10px 0px";
          descLayout.style.margin = "10px 5px";
          descLayout.style.fontSize = "16px";
          let indiDiv = document.createElement("div");
          indiDiv.style.marginBottom = "10px";
          indiDiv.style.textTransform = "capitalize";
          indiDiv.style.display = "flex";
          indiDiv.style.padding = "20px";
          indiDiv.style.width = "fit-content";
          indiDiv.style.backgroundColor = "#f8f8f8";
          let indiText = document.createElement("span");
          indiText.style.display = "inline-block";
          indiText.style.marginTop = "10px";
          indiText.style.marginRight = "30px";
          indiText.innerHTML = "Statement Section";
          indiDiv.appendChild(indiText);
          let indiPill = document.createElement("span");
          indiPill.style.fontWeight = "400";
          indiPill.style.backgroundColor = "#e8e8e8";
          indiPill.style.color = "#333333";
          indiPill.style.border = "none";
          indiPill.style.padding = "5px 20px";
          indiPill.style.margin = "5px 15px";
          indiPill.style.borderRadius = "20px";
          indiPill.style.float = "right";
          indiPill.textContent = data[0];
          indiPill.style.fontSize = "14px";
          indiPill.style.fontWeight = "400";
          indiDiv.appendChild(indiPill);
          descLayout.appendChild(indiDiv);
          secondLine.appendChild(descLayout);

          let endpointLabel = document.createElement("label");
          let endpointInput = document.createElement("ef-text-field");
          endpointLabel.textContent = "Endpoint:";
          endpointLabel.style.fontWeight = "600";
          endpointLabel.style.marginRight = "0px";
          endpointLabel.style.color = "#334d6e";
          endpointLabel.style.fontSize = "16px";
          endpointLabel.style.height = "42px";
          endpointLabel.style.padding = "10px 20px 14px 20px";
          endpointLabel.style.backgroundColor = "#e8e8e8";
          endpointLabel.style.border = "1px solid #e8e8e8";
          endpointInput.value = data[1];
          endpointInput.style.width = "60%";
          endpointInput.style.padding = "10px 20px";
          endpointInput.readOnly = true;
          endpointInput.style.color = "#334d6e";
          endpointInput.style.fontSize = "14px";
          endpointInput.style.border = "1px solid #e8e8e8";
          endpointInput.style.height = "40px";
          thridLine.appendChild(endpointLabel);
          thridLine.appendChild(endpointInput);

          expContent.appendChild(secondLine);
          expContent.appendChild(thridLine);
        }

        rowData = e.originalRowData;
        cell.setContent(expContent);
      } else {
        // dispose
        cell = section.stretchCell(0, rowIndex, false);
        cell.setStyle("backgroundColor", "");
        section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
      }
    }   

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        let rowData = e.data.split(",");
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineIcon = document.createElement("ef-icon");
        let firstLineText = document.createElement("span");
        firstLineIcon.icon = "right";
        firstLineIcon.style.marginRight = "10px";
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine._firstLineIcon = firstLineIcon;
        firstLine.appendChild(firstLineIcon);
        firstLineText.textContent = rowData[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        let secondLine = document.createElement("ef-pill");
        secondLine.style.fontWeight = "400";
        secondLine.style.backgroundColor = "#e5e8ff";
        secondLine.style.color = "#0a0f5c";
        secondLine.style.border = "none";
        secondLine.style.padding = "15px 20px";
        secondLine.style.margin = "10px 25px";
        secondLine.style.borderRadius = "4px";
        secondLine.style.fontSize = "14px";
        content._secondLine = secondLine;
        content.appendChild(secondLine);
        content._secondLine.textContent = rowData[2];

        let secondLine2 = document.createElement("ef-pill");
        let secondLine22 = document.createElement("span");
        let secondLine2Icon = document.createElement("img");
        secondLine2Icon.src = fileKeyImg;
        secondLine2Icon.style.marginRight = "5px";
        secondLine2Icon.style.marginTop = "5px";
        secondLine22._secondLine2Icon = secondLine2Icon;
        secondLine22.appendChild(secondLine2Icon);
        secondLine2.style.fontWeight = "400";
        secondLine2.style.backgroundColor = "transparent";
        secondLine2.style.color = "#999999";
        secondLine2.style.border = "none";
        secondLine22.textContent = rowData[1];
        secondLine22.style.fontSize = "14px";
        secondLine22.style.display = "inline-flex";
        secondLine22.style.verticalAlign = "super";
        secondLine2.appendChild(secondLine2Icon);
        secondLine2.appendChild(secondLine22);
        content._secondLine2 = secondLine2;
        content.appendChild(secondLine2);

        let secondLine3 = document.createElement("ef-pill");
        let secondLine33 = document.createElement("span");
        let secondLine3Icon = document.createElement("img");
        secondLine3Icon.src = vectorImg;
        secondLine3Icon.style.marginRight = "5px";
        secondLine3Icon.style.marginTop = "5px";
        secondLine33._secondLine3Icon = secondLine3Icon;
        secondLine33.appendChild(secondLine3Icon);
        secondLine3.style.fontWeight = "400";
        secondLine3.style.backgroundColor = "transparent";
        secondLine3.style.color = "#999999";
        secondLine3.style.border = "none";
        secondLine33.textContent = rowData[3];
        secondLine33.style.fontSize = "14px";
        secondLine33.style.display = "inline-flex";
        secondLine33.style.verticalAlign = "text-bottom";
        secondLine3.appendChild(secondLine3Icon);
        secondLine3.appendChild(secondLine33);
        content._secondLine3 = secondLine3;
        content.appendChild(secondLine3);

        content.addEventListener("click", function() {
          if (firstLineIcon.icon === "right") {
            firstLineIcon.icon = "down";
          } else {
            firstLineIcon.icon = "right";
          }
        });
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };
    
    if(!wealth){
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData,
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index`
              sortOrder: "a"
          }
        },
        rowExpansionBinding: onRowExpansionBinding
      };
    }
  }, [fullData, searchData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div>
          <h4>SEGMENTS</h4>
          <p>This is a list of all the segments available per customer use case and package. Segments are available for Business, Product and Geographics.<br></br>Segment packages are available as add-on only to the Financial Statement and Fundamental Ratios (Analytics) packages. They are included in the Company Snapshot packages for the relevant use cases.</p>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
               <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}

export default Segments;
